// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import fullpage from "v-fullpage";
// import 'fullpage.js/vendors/scrolloverflow'
// import VueFullPage from 'vue-fullpage.js'
//样式文件，需单独引入
import 'element-ui/lib/theme-chalk/index.css';
//引入写有需要的组件的文件
import element from './element/index'
import vueTouch from 'kim-vue-touch'

Vue.use(element)
Vue.use(fullpage);
Vue.use(vueTouch)
// Vue.use(VueFullPage);
Vue.config.productionTip = false
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  console.log('asda---', to)
  if (to.name == 'collegeDetail' || to.name == 'college' ||  to.name == 'Home' ||  to.name == 'activity' ||  to.name == 'periphery' ) {
    store.commit('isAlphaEdit', true)
  } else {
    store.commit('isAlphaEdit', false)
  }
  var sUserAgent = navigator.userAgent.toLowerCase()
  // var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
  var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
  var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
  var bIsAndroid = sUserAgent.match(/android/i) == 'android'
  var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
  var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
  if ( bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    store.commit('isPCEdit', false)
  } else {
    console.log('pc')
    store.commit('isPCEdit', true)
  }
  next()
})



new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js